<template>
  <new-modal-wrapper
    ref="vueUploadModal"
    modal-name="uploadModal"
    :show-close-icon="false"
    :click-to-close="false"
    class="new-file-upload"
    :showHeaderAria="true"
    :overrideFocusValue="false"
  >
    <h2 
      id="customs-vmodal-header-title" 
      class="text-center new-file-upload-header"
    >{{ translations.uploadModalHeader }}</h2>
    <div class="content">
      <div class="text-center">
        <base-spinner size="50" position="static"></base-spinner>
      </div>

      <h5 class="text-center new-file-upload-subheader header--no-text-transform">
        {{ translations.uploadModalSubHeader1 }}
        <br />
        {{ translations.uploadModalSubHeader2 }}
      </h5>
    </div>
  </new-modal-wrapper>
</template>

<script>
import newModalWrapper from '@/components/Modals/NewModalWrapper/NewModalWrapper';
import baseSpinner from '@/components/Spinner';

export default {
  name: "vue-upload-modal",
  computed: {
    translations() {
      return this.$store.state.translations.data;
    }
  },
  components: {
    baseSpinner,
    newModalWrapper
  }
};
</script>
